/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 8/9/2022
 */
import BaseObject from "@shared/BaseObject.js";

export default class InvoicesInfo extends BaseObject {

	clientId: string = null
	invoiceId: string = null
	installmentsTotal: number = 1
	installmentsPaid: number = 0
	amountTotal: number = 0
	amountPaid: number = 0

	validTillMs: number = -1


	constructor() {
		super();
	}

	setInvoice(invoiceItem){
		this.invoiceId = invoiceItem.id
		this.amountTotal = invoiceItem.getTotalAmount()
		this.installmentsTotal = invoiceItem.getInstallmentsTotal()
		this.validTillMs = invoiceItem.validTillMs || -1
		this.setInstallmentPaid(invoiceItem)
	}
	setInstallmentPaid(invoiceItem){
		this.amountPaid += invoiceItem.getAmountPaid()
		this.validTillMs = invoiceItem.validTillMs || -1
		this.installmentsPaid++
	}

	migrateSchema(){
		if(this.invoiceIds && this.invoiceIds.length > 0){
			this.invoiceId = this.invoiceIds[0]
			this.installmentsPaid = 1
			this.invoiceIds = null
		}
	}

}
